import DealsIcon from '@crm/shared/assets/icons/nav-deals.svg?react';
import InWorkOrFinishedIcon from '@crm/shared/assets/icons/nav-in-work-or-finished.svg?react';
import LostIcon from '@crm/shared/assets/icons/nav-lost.svg?react';
import PostponedIcon from '@crm/shared/assets/icons/nav-postponed.svg?react';
import TasksIcon from '@crm/shared/assets/icons/nav-tasks.svg?react';
import { ROUTES } from '@crm/shared/routes';

// import DealsIcon from '../assets/nav-deals.png';
// import InWorkOrFinishedIcon from '../assets/nav-in-work-or-finished.png';
// import LostIcon from '../assets/nav-lost.png';
// import PostponedIcon from '../assets/nav-postponed.png';
// import TasksIcon from '../assets/nav-tasks.png';

export const addMenuData = [
    {
        menuTextKey: 'crm.appMenu.items.deals',
        route: ROUTES.DEALS,
        icon: DealsIcon,
    },
    {
        menuTextKey: 'crm.appMenu.items.tasks',
        route: ROUTES.TASKS,
        icon: TasksIcon,
    },
    {
        menuTextKey: 'crm.appMenu.items.postponed',
        route: ROUTES.POSTPONED_DEALS,
        icon: PostponedIcon,
    },
    {
        menuTextKey: 'crm.appMenu.items.inWorkOrFinished',
        route: ROUTES.IN_WORK_OR_FINISHED_DEALS,
        icon: InWorkOrFinishedIcon,
    },
    {
        menuTextKey: 'crm.appMenu.items.lost',
        route: ROUTES.LOST_DEALS,
        icon: LostIcon,
    },

    // {
    //     menuTextKey: 'crm.appMenu.items.leads',
    //     route: ROUTES.LEADS,
    //     icon: LeadsIcon,
    // },
    // {
    //     menuTextKey: 'crm.appMenu.items.dashboard',
    //     route: ROUTES.DASHBOARD,
    //     icon: DashIcon,
    // },
];
